<template>
  <div>

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="closeMessage()"
    ></dlnkalert>

    <div id="content" class="dlnkcalendar-multi-registration">

      <div class="position-relative bg-primary overflow-hidden">
        <div class="container position-relative z-index-2 space-top-1 space-top-md-1 space-bottom-1 space-bottom-md-1">
          <div class="w-md-80 w-xl-60 text-center mx-md-auto">
            <h1 class="text-white mb-4">{{ event.event_name }}</h1>
          </div>
        </div>
        <figure class="position-absolute right-0 bottom-0 left-0 mb-n1">
          <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
            <path fill="#F9F9F9" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>
          </svg>
        </figure>
      </div>

      <hr class="my-3">

      <div class="container">
        <div v-if="already_reserved > 0" class="mt-6">
          <p class="alert alert-danger h4">
            Vous avez déjà une pré-réservation pour cette activité
          </p>
        </div>
        <div v-else>
          <div v-if="availability > 0" id="reservation">

            <p>
              Communiquez nous le nombre d'enfants que vous souhaitez inscrire à l'activité. <br>
              Puis selectionner un créneau de rendez vous sur le calendrier.
            </p>

            <form class="form-inline">

              <div class="form-group mb-2 mr-2">
                <span class="label">Il reste <strong>{{ availability }}</strong> places</span>
              </div>

              <div class="form-group mb-2 mr-2">
                <input type="number" class="form-control form-control-xs" placeholder="1" v-model="childCount">
              </div>

              <button type="button" class="btn btn-primary mb-2 mr-1" @click.prevent="removeChild()">
                <i class="fas fa-minus"></i>
              </button>

              <button type="button" class="btn btn-primary mb-2" @click.prevent="addChild()">
                <i class="fas fa-plus"></i>
              </button>
            </form>

            <div class="mt-6" id="reservation-calendar">
              <FullCalendar ref="reservationCalendar" :options="calendar_options"/>
            </div>

          </div>
          <div v-else class="mt-6">
            <p class="alert alert-danger h4">
              Désolé, il ne reste plus de place disponible.
              <br>
              Vous pouvez vous enregistrer sur une liste d'attente.
            </p>

            <div id="waitings" v-if="event.waiting_list == 1" class="mt-6">

              <form class="form-inline">
                <div class="form-group mb-2 mr-1">
                  <input ref="firstname_input" type="text" class="form-control form-control-xs" placeholder="Prénom"
                         v-model="firstname">
                </div>
                <div class="form-group mb-2 mr-1">
                  <input type="text" class="form-control form-control-xs" placeholder="Nom" v-model="lastname">
                </div>
                <div class="form-group mb-2 mr-2">
                  <input type="text" class="form-control form-control-xs" placeholder="Téléphone" v-model="phone">
                </div>
                <div class="form-group mb-2 mr-2">
                  <input type="text" class="form-control form-control-xs" placeholder="Niveau" v-model="niveau">
                </div>

                <button type="submit" class="btn btn-primary mb-2" @click.prevent="addParticipant()">
                  <i class="fas fa-plus"></i>
                </button>

                <button v-if="participants.length > 0" type="button" class="btn btn-primary mb-2 ml-6" @click.prevent="sendWaitingList()">
                  <i class="fas fa-save"></i>&nbsp;Valider
                </button>
              </form>

              <table class="table">
                  <thead>
                  <tr>
                    <th>Prénom</th>
                    <th>Nom</th>
                    <th>Téléphone</th>
                    <th>Niveau</th>
                    <th>Action</th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr v-for="participant, index in participants" :key="index">
                    <td>{{ participant.firstname }}</td>
                    <td>{{ participant.lastname }}</td>
                    <td>{{ participant.phone }}</td>
                    <td>{{ participant.niveau }}</td>
                    <td>
                      <a href="javascript:void(0);" class="btn btn-xs btn-icon btn-outline-danger rounded-circle"
                         data-toggle="tooltip" data-placement="top" title="Supprimer le participant"
                         @click="deleteParticipant(index)">
                        <i class="fas fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                  </tbody>
                </table>
            </div>

          </div>
        </div>


        <div class="mt-6">
          <p id="confirmation" class="alert alert-info h4 d-none">
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import frLocale from '@fullcalendar/core/locales/fr';

export default {

  components: {
    FullCalendar // make the <FullCalendar> tag available
  },

  props: [
    'event_id',
    'customer_id',
    'customer_lastname',
    'customer_firstname',
    'customer_mobile',
    'customer_email',
    'api_url',
  ],

  data: function () {
    const _this = this
    return {
      customer: Object,
      message: '',
      message_type: '',
      availability: Number,
      event: Object,
      already_reserved: Number,
      childCount: Number,
      firstname: String,
      lastname: String,
      phone: String,
      niveau: String,
      participants: Array(),
      calendar_options: {
        events: [],
        editable: false,
        navLinks: true,
        timeZone: 'Europe/Paris',
        locale: frLocale,
        initialDate: new Date('2022-09-12T15:00:00'),
        initialView: 'dayGridWeek',
        eventDisplay: 'block',
        plugins: [dayGridPlugin, timeGridPlugin],

        eventClick: function (info) {
          _this.eventClick(info)
        },

      },
    }
  },

  mounted() {
    this.childCount = 1
    this.getData()
    this.getCalendar()
    this.firstname = ""
    this.lastname = ""
    this.phone = ""
    this.niveau = ""
  },

  watch: {
    childCount: function (new_val, old_val) {
      const _this = this
      if (new_val > 3) {
        _this.childCount = old_val
      }

      if (new_val < 1) {
        _this.childCount = old_val
      }
    }
  },

  methods: {

    // Gestion du formulaire de liste d'attente
    //
    addParticipant: function () {
      let participant = new Object()

      if (this.checkInput()) {
        participant.lastname = this.lastname
        participant.firstname = this.firstname
        participant.phone = this.phone
        participant.niveau = this.niveau
        participant.event_id = this.event_id


        this.participants.push(participant)
        this.$refs.firstname_input.focus();
        this.clearForm()
      }
    },

    checkInput: function () {
      if (this.lastname.length < 2) {
        this.message = 'Nom incorrect'
        this.message_type = 'alert-danger'
        this.lastname = ""
        return false
      }

      if (this.firstname.length < 2) {
        this.message = 'Prénom incorrect'
        this.message_type = 'alert-danger'
        this.firstname = ""
        return false
      }

      return true
    },

    clearForm: function () {
      this.lastname = ""
      this.firstname = ""
      this.niveau = ""
      this.phone = ""
    },

    deleteParticipant: function (index) {
      this.participants.splice(index, 1)
    },

    sendWaitingList: async function () {
      const _this = this

      if (_this.participants.length < 1) {
        this.message = 'Vous devez rajouter des participants'
        this.message_type = 'alert-danger'
        this.lastname = ""
        return false
      }

      const go = confirm("Je confirme mon inscription sur la liste d'attente")
      if (go) {
        const secure_key = await get_token();

        let url = this.api_url + '/event_waiting_lists.json';

        url += '?secure_key=' + secure_key;
        url += '&customer_id=' + _this.customer_id

        const participants = JSON.stringify(_this.participants);

        const data = {
          event_waiting_list: {
            customer_id: _this.customer_id,
            event_id: _this.event_id,
            event_waiting_list_details_attributes: _this.participants
          },
        }

        axios({
          method: 'post',
          url: url,
          data: data,
        })
            .then(function (response) {
              //handle success
              const status = response.data.status;

              if (status == 1) {
                _this.message = "Votre inscription en liste d'attente est enregistrée"
                _this.message_type = "alert-success"
                document.getElementById('waitings').remove()
                document.getElementById('confirmation').innerHTML = "Votre inscription en liste d'attente est enregistrée"
                document.getElementById('confirmation').classList.remove('d-none')


              } else {
                _this.message = response.data.message;
                _this.message_type = "alert-danger";
              }
            })
            .catch(function (response) {
              alert('Erreur inconnu');
            });
      }
    },

    //
    // Fin Gestion du formulaire de liste d'attente

    eventClick: async function (info) {
      const _this = this
      const event = info.event
      const appointment_date = event.extendedProps['start_date']
      const go = confirm("Veuillez confirmer votre rendez-vous pour le " + appointment_date)
      if (go) {
        const secure_key = await get_token();
        const appointmentId = info.event.id

        let url = this.api_url + '/event_reservations.json';

        url += '?secure_key=' + secure_key;
        url += '&customer_id=' + _this.customer_id

        let formData = new FormData();
        formData.append('event_reservation[id_event]', _this.event_id)
        formData.append('event_reservation[id_user]', _this.customer_id)
        formData.append('event_reservation[reservation_quantity]', _this.childCount)
        formData.append('event_reservation[reservation_lastname]', _this.customer_lastname)
        formData.append('event_reservation[reservation_firstname]', _this.customer_firstname)
        formData.append('event_reservation[phone]', _this.customer_name)
        formData.append('event_reservation[reservation_email]', _this.customer_email)
        formData.append('event_reservation[appointment_id]', appointmentId)

        axios({
          method: 'post',
          url: url,
          data: formData,

        })
            .then(function (response) {
              //handle success
              const status = response.data.status
              const date = response.data.date

              if (status) {
                _this.message = "Votre rendez-vous est enregistrée"
                _this.message_type = "alert-success"
                document.getElementById('reservation').remove()
                document.getElementById('confirmation').innerHTML = 'Votre rendez-vous pour le ' + appointment_date + ' est enregistrée'
                document.getElementById('confirmation').classList.remove('d-none')
              } else {
                _this.message = response.data.errors;
                _this.message_type = "alert-danger";
              }
            })
            .catch(function (response) {
              alert('Erreur inconnu 2');
            });

      } else {
        alert('stop')
      }
    },

    addChild: function () {
      let _this = this
      if (_this.childCount < _this.availability && _this.childCount < 3) {
        _this.childCount++
      }
    },

    removeChild: function () {
      let _this = this
      if (_this.childCount > 0) {
        _this.childCount--
      }
    },

    closeMessage: function () {
      this.message = "";
      this.message_type = "";
    },

    getCalendar: async function () {
      const _this = this
      const secure_key = await get_token();
      const url = _this.api_url + '/event_appointments.json?secure_key=' + secure_key + '&customer_id=' + _this.customer_id + '&event_id=' + _this.event_id
      if( _this.$refs.reservationCalendar !== undefined ) {
        let calendar = _this.$refs.reservationCalendar.getApi()
        calendar.addEventSource(url)
      }
    },


    getData: function () {
      const _this = this

      const url = '/modules/dlnkcalendar/actions/events.php?action=event&event_id=' + _this.event_id

      axios.get(url)
          .then(function (response) {
            _this.event = response.data.event
            _this.availability = parseInt(_this.event.availability)
            _this.already_reserved = parseInt(response.data.already_reserved)
            _this.customer = response.data.customer
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

  }
}

</script>
